module.exports = __webpack_public_path__ + "static/img/product-3.52d9af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/product-3.png
// module id = j0du
// module chunks = 49